export enum OfficeOnlineApp {
    Word,
    Excel,
    PowerPoint,
}
